import { IFittingEvaluation } from '../types';
import ReactStars from "react-rating-stars-component";
import s from './fittingEvaluationItemList.module.css';
import { Link } from "react-router-dom";
import { useEffect, useRef, useState } from "react";

export default function FittingEvaluationItemList({ evaluation }: { evaluation: IFittingEvaluation }) {
    const [isOpen, setIsOpen] = useState(false);
    const [previewPhoto, setPreviewPhoto] = useState<boolean>(false);
    const overlayRef = useRef<HTMLDivElement>(null);
    const handleOverlayClick = (e: React.MouseEvent) => {
        if (e.target === overlayRef.current) {
            setPreviewPhoto(false);
        }
    };

    const changeOpen = () => {
        setIsOpen(!isOpen);
    };

    const formatDate = (sendFeedbackDate: string) => {
        try {
            const date = new Date(sendFeedbackDate);
            return new Intl.DateTimeFormat('ru-RU', {
                day: 'numeric',
                month: 'long',
                year: 'numeric',
                hour: '2-digit',
                minute: '2-digit'
            }).format(date);
        } catch {
            return sendFeedbackDate;
        }
    };

    useEffect (() => {
        setIsOpen(false);
    }, [evaluation])

    return (
        <div className={s.card}>
            <div className={s.header} onClick={changeOpen}>
                <div className={s.userInfo}>
                    <span className={s.userName}>{evaluation.userName}</span>
                    <span className={s.userEmail}>{evaluation.userEmail}</span>
                </div>
                <div className={s.date}>
                    {formatDate(evaluation.sendFeedbackDate)}
                </div>
                <div className={s.openIcon}>
                    {isOpen ? '▲' : '▼'}
                </div>
            </div>

            {isOpen && (
                <>
                    <div className={s.ratingSection}>
                        <div className={s.ratingHeading}>
                            <span className={s.ratingValue}>{evaluation.mark.toFixed(1)}</span>
                            <ReactStars
                                count={5}
                                value={evaluation.mark}
                                size={24}
                                color="#FFD700"
                                edit={false}
                            />
                        </div>

                        <div className={s.feedback}>
                            <div className={s.phrases}>
                                {evaluation.phrases.map((phrase: string, i: number) => (
                                    <span key={i} className={s.phraseTag}>{phrase}</span>
                                ))}
                            </div>
                            {evaluation.review && (
                                <p className={s.review}>"{evaluation.review}"</p>
                            )}
                        </div>
                    </div>

                    <div className={s.outfitComposition}>
                        <h3 className={s.compositionTitle}>Фото переодевания</h3>
                        <div className={s.itemsGrid}>
                                    <div className={s.itemCard}>
                                            <div className={s.itemFittingContainer}>
                                                <img
                                                    src={evaluation.fittingPhotoUrl}
                                                    className={s.itemFitting}
                                                    onClick={() => setPreviewPhoto(true)}
                                                />
                                            </div>
                                    </div>
                        </div>
                    </div>
                    {previewPhoto && (<div
                        ref={overlayRef}
                        className={`${s.previewOverlay} ${previewPhoto ? s.active : ''}`}
                        onClick={handleOverlayClick}
            >
                    <div className={s.previewPhoto}>
                        <button
                            className={s.closePreview}
                            onClick={() => setPreviewPhoto(false)}
                            aria-label="Закрыть"
                        >
                            ×
                        </button>

                        <img
                            src={evaluation.fittingPhotoUrl}
                            alt='Изображение'
                        />
                    </div>
                </div>)}
                </>
            )}
        </div>
    );
}